import axios from "axios";

export const BASE_URL = "https://csr.thecanatech.com"; 

const API = axios.create({
  baseURL: `${BASE_URL}/api`
}); 

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;
